module.exports = __webpack_public_path__ + "img/ilya-kuvshinov-fox.799a3b4.jpg";